import React from 'react'
import styled from 'styled-components'

import Brand from './Brand'
import FooterNav from './FooterNav'
import Disclaimer from './Disclaimer'
// import Toggle from './Toggle'

const Footer = () => {
  return (
    <Wrapper className="footer">
      <Container>
        <Brand />
        <FooterNav />
        {/* <Toggle /> */}
        <Disclaimer>
          This website is intended as an educational resource.
          <br />
          All rights reserved to the copyright owners.
        </Disclaimer>
      </Container>
    </Wrapper>
  )
}

const Wrapper = styled.footer`
  position: relative;
  background: var(--color-primary);
  font-weight: 500;
  color: var(--color-text);

  [color-scheme='rwa-light'] & {
    color: var(--color-light);
  }

  h2 {
    margin-bottom: 0.25em;
    border-bottom: solid 1px var(--color-text1);

    [color-scheme='rwa-light'] & {
      border-bottom: solid 1px var(--color-light);
    }
  }
`

const Container = styled.div`
  width: 100%;
  max-width: var(--max-width);
  margin: 0 auto;
  padding: var(--size-6) var(--padding-x) var(--size-10);
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: auto;
  grid-gap: var(--size-4);

  @media (min-width: 768px) {
    grid-template-columns: auto minmax(0, 1fr);
  }

  .brand {
    grid-column: 1 / 2;
    grid-row: 2 / 3;
    display: flex;
    justify-content: center;

    @media (min-width: 768px) {
      display: block;
      grid-column: 1 / 2;
      grid-row: 1 / 2;
    }
  }

  .nav {
    grid-column: 1 / 2;
    grid-row: 1 / 2;

    @media (min-width: 768px) {
      grid-column: 2 / 3;
      grid-row: 1 / 2;
    }
  }

  .disclaimer {
    grid-column: 1 / 2;
    grid-row: 3 / 4;
    display: flex;
    justify-content: center;
    text-align: center;

    @media (min-width: 768px) {
      display: block;
      justify-content: center;
      text-align: left;
      grid-column: 1 / 3;
      grid-row: 2 / 3;
    }
  }

  /* .toggle {
    grid-column: 1 / 2;
    grid-row: 3 / 4;

    @media (min-width: 768px) {
      grid-row: 2 / 3;
      grid-column: 1 / -1;
    }
  } */
`

export default Footer
